<template>
  <label :class="sizeList[size]" @click="$emit('click')">
    <span class="bc-input" :class="{ checked: checked }"></span>
    <span class="bc-span" :class="{ select: checked }"></span>
  </label>
</template>

<script>
/**
 * 使用方法：
 * <check-box size="big" :checked="isChecked"></check-box>
 * api:
 * size: 复选框尺寸，提供两种选择， small和big
 * checked: 是否选中
 */
export default {
  name: 'checkbox',
  props: ['size', 'checked'],
  data() {
    return {
      sizeList: {
        small: 'base-checkbox-s',
        big: 'base-checkbox-b',
      },
    };
  },
};
</script>

<style lang="less" scoped>
.base-checkbox-s,
.base-checkbox-b {
  position: relative;
  line-height: 1;
  padding: 2px 0 1px;
  .bc-input {
    display: none;
  }
  .bc-span {
    display: inline-block;
    position: relative;
    width: 10px;
    height: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 2px;
  }
  .bc-input.checked + .bc-span:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 3px;
    border: 1px solid #ffffff;
    border-top: 0;
    border-right: 0;
    top: 2px;
    left: 1px;
    -ms-transform: rotate(-55deg);
    -moz-transform: rotate(-55deg);
    -webkit-transform: rotate(-55deg);
    transform: rotate(-55deg);
  }
  .bc-span.select {
    background: #f16622;
    border: 1px solid #f16622;
  }
}
.base-checkbox-b {
  .bc-span {
    width: 18px;
    height: 18px;
  }
  .bc-input.checked + .bc-span:after {
    border-width: 2px;
    width: 10px;
    height: 5px;
    top: 4px;
    left: 3px;
  }
}
</style>
